export enum RowActionType {
    UpdateContent,
    Remove,
}
